<script>
import certificadosDigitais from "../../../api/certificados-digitais";

export default {
  name: "ExcluirCertificadoDigitalModal",
  props: {
    visible: {
      required: true,
      type: Boolean
    },
    certificado: {
      type: Object,
      default: () => {},
    }
  },
  data () {
    return {
      closeButton: false,
      loading: false,
      form: {
        frase: '',
        error: '',
      }
    }
  },
  computed: {
    formInvalido() {
      return this.form.frase !== 'DELETAR' || !this.form.frase.length
    }
  },
  methods: {
    fecharModal() {
      this.form.certificado = null;
      this.$emit("closeModal");
    },
    onSubmit() {
      this.loading = true;
      this.closeButton = true;


      certificadosDigitais.deletar(this.certificado.id)
        .then(() => {
          this.form.error = '';
          window.location.reload();
        })
        .catch(() => {
          this.form.error = 'Não encontrado';
        })
        .finally(() => {
          this.loading = false;
          this.closeButton = false;
        });
    },
  }
}
</script>

<template>
  <div>
    <modal
        size="small"
        ref="modal"
        :hideCloseButton="closeButton"
        v-if="visible"
        @close-modal="fecharModal"
      >
        <div slot="header">
          Deseja excluir este certificado?
        </div>
        <div class="container" slot="content">
          <p>Digite <b>DELETAR</b> para continuar:</p>
          <form id="form-certificado" v-on:submit.prevent="onSubmit">
            <div class="form-box form-creditos">
              <label class="label">Texto</label>
              <input
                class="field name-w"
                type="text"
                name="senha"
                required="required"
                v-model="form.frase"
                autocomplete="off"
              />
            </div>
            <span class="Message -fail" v-text="this.form.error"></span>
            <Btn
              class="btn negative"
              type="submit"
              :loading="loading"
              :disabled="loading || formInvalido"
              @click="onSubmit"
            >
              <b>Excluir</b>
            </Btn>
          </form>
        </div>
        <div slot="footer"></div>
      </modal>
  </div>

</template>

<style scoped lang="stylus">
</style>
